import { withDependencies } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { WixBiSession, IFetchApi, ServiceProvider } from '@wix/thunderbolt-symbols'
import { WixBiSessionSymbol, Fetch, METASITE_APP_DEF_ID } from '@wix/thunderbolt-symbols'
import type { ISessionManager } from 'feature-session-manager'
import { SessionManagerSymbol } from 'feature-session-manager'
import type { IBsiManager } from 'feature-business-logger'
import { BsiManagerSymbol } from 'feature-business-logger'
import type {
	IBusinessLoggerDefinition,
	IBusinessLoggerServiceConfig,
} from '@wix/viewer-service-business-logger/definition'
import { BusinessLoggerDefinition as definition } from '@wix/viewer-service-business-logger/definition'
import { InternalBusinessLoggerService as impl } from '@wix/viewer-service-business-logger/implementations/internalBusinessLoggerService'

export const businessLoggerService: FactoryWithDependencies<ServiceProvider<IBusinessLoggerDefinition, typeof impl>> =
	withDependencies(
		[WixBiSessionSymbol, SessionManagerSymbol, Fetch, BsiManagerSymbol],
		(
			wixBiSession: WixBiSession,
			sessionManager: ISessionManager,
			fetchApi: IFetchApi,
			bsiManager: IBsiManager
		): ServiceProvider<IBusinessLoggerDefinition, typeof impl> => {
			const config: IBusinessLoggerServiceConfig = {
				metaSiteAppDefId: METASITE_APP_DEF_ID,
				getBsi: bsiManager?.getBsi ?? (() => ''),
				wixBiSession,
				sessionManager: {
					getSiteMemberId: sessionManager.getSiteMemberId,
					getVisitorId: sessionManager.getVisitorId,
					addLoadNewSessionCallback: sessionManager.addLoadNewSessionCallback,
				},
				envFetch: fetchApi.envFetch,
			}

			return {
				definition,
				impl,
				config,
				platformConfig: {},
			}
		}
	)

export { definition, impl }
